import merchantsList from './merchantsList';

export default merchantsList;
